<template>
  <div class="dlnkvotes_component w-100">

    <dlnkalert
        :message="message"
        :message_type="message_type"
    ></dlnkalert>

    <div class="row" v-if="homepage">
      <div v-for="referendum, index in referendums" :key="referendum.id" v-if="index < 3"
          class="col-12 mb-3">
        <dlnkvotes-vote
            :referendum="referendum"
            :is_admin="!!is_admin"
            @refresh="get_referendums()"
            :homepage="homepage"
        ></dlnkvotes-vote>
      </div>
    </div>

    <div v-else class="container">
      <div class="row align-items-center mb-3">
        <div class="col-4">
          <button @click="new_referendum()"
                  v-if="!!is_admin || member_status == 0"
                  type="button"
                  class="btn btn-primary">
            <i class="fa fa-plus" aria-hidden="true"></i>&nbsp;Proposer un nouveau vote
          </button>
        </div>

        <div class="col-4">
          <div class="d-flex align-items-center justify-content-center justify-content-md-end text-center text-sm-left">
            <div class="dropdown dropleft">
              <button id='dropdown-sort' class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-filter mr-1"></i>&nbsp;Trier par
              </button>
              <div class="dropdown-menu dropdown-sort">
                <a class="dropdown-item" href="javascript:" v-on:click="sort('created_at', 'desc')">
                  Date d'ajout (plus récents)
                </a>
                <a class="dropdown-item" href="javascript:" v-on:click="sort('created_at', 'asc')">
                  Date d'ajout (plus anciens)
                </a>
                <a class="dropdown-item" href="javascript:" v-on:click="sort('updated_at', 'desc')">
                  Date de modification (plus récents)
                </a>
                <a class="dropdown-item" href="javascript:" v-on:click="sort('updated_at', 'asc')">
                  Date de modification (plus anciens)
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- SEARCH -->
        <div class="col-4">
          <input v-on:keyup="search_referendums" type="text" placeholder="Rechercher ..." class="form-control-sm w-100 border" v-model="query">
        </div>
        <!-- END SEARCH -->
      </div>

      <!--  REFERENDUM MODAL -->
      <div class="modal fade text-body" id="referendum_modal" tabindex="-1" role="dialog"
            aria-labelledby="new_referendum_modalLabel">
        <form id="referendum_form"
              enctype="multipart/form-data"
              method="post"
              @submit.prevent="post_referendum"
              class="needs-validation" novalidate>
          <input type="hidden" name="method" :value="method">
          <input type="hidden" name="referendum_id" :value="referendum_id">
          <input type="hidden" name="group_id" :value="group_id">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" v-if="method === 'patch'">Modifier un vote</h4>
                <h4 class="modal-title" v-else>Proposer un nouveau vote</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Fermer"><span
                    aria-hidden="true">&times;</span></button>
              </div>

              <div class="modal-body">
                <div class="form-group">
                  <label for="dlnkvotes-title">Thème :</label>
                  <select class="form-control form-control-sm"
                          name="dlnkvotes-theme"
                          v-model="id_theme" required>
                    <option v-for="theme in themes" :value="theme.id">{{ theme.title }}</option>
                  </select>
                  <div class="invalid-feedback">
                    Vous devez choisir une section
                  </div>
                </div>
                <div class="form-group">
                  <label for="dlnkvotes-title">Titre :</label>
                  <input type="text"
                          class="form-control"
                          id="dlnkvotes-title"
                          name="dlnkvotes-title"
                          v-model="title" minlength="3" maxlength="128" required>
                  <div class="invalid-feedback">
                    Le titre doit contenir entre 3 et 128 caractères.
                  </div>
                </div>
                <div class="form-group">
                  <label for="dlnkvotes-description">Description :</label>
                  <textarea type="text"
                            class="form-control"
                            id="dlnkvotes-description"
                            name="dlnkvotes-description"
                            v-model="description"
                            minlength="3"></textarea>
                  <div class="invalid-feedback">
                    La description doit contenir au minimum 3 caractères.
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal">
                  <i class="fa fa-times" aria-hidden="true"></i>&nbsp;Annuler
                </button>
                <button
                    type="submit"
                    class="btn btn-primary"
                    name="new_referendum" >
                  <i class="fa fa-save" aria-hidden="true"></i>&nbsp;Valider
                </button>
              </div>
            </div>
          </div>

        </form>

      </div>
      <!--  END REFERENDUM MODAL -->

      <div class="row">
        <div v-for="referendum in referendums" :key="referendum.id"
              class="col-sm-6 col-lg-4 mb-3 mb-sm-8">

          <dlnkvotes-vote
              :referendum="referendum"
              :is_admin="!!is_admin"
              @refresh="get_referendums()"
              @edit_referendum="edit_referendum($event)"
              @delete_referendum="delete_referendum($event)"
          ></dlnkvotes-vote>

        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  props: {
    'group_id': Number,
    'homepage': Boolean
  },
  data: function () {
    return {
      message: '',
      message_type: '',
      method: 'post',
      query: '',
      order_by: 'created_at',
      order_direction: 'DESC',
      referendums: Array,
      referendum_id: 0,
      title: '',
      description: '',
      id_theme: 0,
      company: Object,
      is_admin: Boolean,
      errors: {},
      themes: Array
    }
  },

  mounted() {
    this.get_referendums();
  },

  computed: {},

  methods: {

    close_message: function () {
      this.message = "";
      this.message_type = "";
    },
    
    get_referendums: function () {
      const _this = this

      const url = '/modules/dlnkvotes/actions/referendums.php'

      axios.get(url +
          '?group_id=' + _this.group_id +
          '&query=' + _this.query +
          '&order_by=' + _this.order_by +
          '&order_direction=' + _this.order_direction)
          .then(function (response) {
            _this.themes = response.data.themes
            _this.referendums = response.data.referendums
            _this.company = response.data.company
            _this.is_admin = response.data.is_admin
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    sort: function (order_by, order_direction) {
      this.order_by = order_by;
      this.order_direction = order_direction;
      $('#dropdown-sort').dropdown('toggle');
      this.get_referendums();
    },

    new_referendum: function(referendum) {
      this.referendum_id = 0;
      this.theme_id = 0;
      this.title = "";
      this.description = "";
      this.method = 'post'

      $('#referendum_modal').modal('show');
    },

    edit_referendum: function(referendum) {
      this.referendum_id = referendum.id;
      this.id_theme = referendum.id_theme;
      this.title = referendum.title;
      this.description = referendum.description;
      this.method = 'patch'

      $('#referendum_modal').modal('show');
    },

    delete_referendum: function(referendum_id) {
      const _this = this;
      const url = '/modules/dlnkvotes/actions/referendums.php';
      const form_data = new FormData();
      form_data.append('method', 'delete');
      form_data.append('referendum_id', referendum_id);

      axios({
        method: 'post',
        url: url,
        data: form_data,
        headers: {'Content-Type': 'multipart/form-data' }
      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if(status) {
              _this.get_referendums();
              _this.message = "vote supprimé.";
              _this.message_type = "alert-success"
            } else {
              _this.errors = response.data.errors;
            }
          })
          .catch(function (response) {
            //handle error
          });
    },

    post_referendum: function () {
      const _this = this;
      const url = '/modules/dlnkvotes/actions/referendums.php';

      const form_element = document.getElementById("referendum_form");
      const form_data = new FormData(form_element);

      axios({
        method: 'post',
        url: url,
        data: form_data,
        headers: {'Content-Type': 'multipart/form-data' }
      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if(status) {
              $('#referendum_modal').modal('hide');
              _this.get_referendums();
              if (_this.method === 'post') {
                _this.message = "Vote proposé.";
                _this.message_type = "alert-success"
              }
            } else {
              _this.errors = response.data.errors;
            }
          })
          .catch(function (response) {
            //handle error
          });
    },

    search_referendums() {
      this.get_referendums();
    }
  },
}
</script>
